/**
 * @typedef {Object} BreadcrumbItem
 * @property {string} text - パンくずに表示されるテキスト
 * @property {string} [link] - パンくずのページURL（リンクがない場合は省略可）
 */

/**
 * パンくず用の JSON-LD を設定する composable
 *
 * @param {BreadcrumbItem[]} breadCrumb パンくずリスト
 */

export function useCustomJsonld(breadCrumb) {
  const config = useRuntimeConfig()

  useJsonld(() => (
    [{
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        {
          '@type': 'ListItem',
          'position': 1,
          'item': {
            '@id': `${config.public.hostDomain}`,
            'name': 'トップ'
          }
        },
        ...breadCrumb.map((item, index) => {
          return {
            '@type': 'ListItem',
            'position': index + 2,
            'item': {
              ...(item.link ? { '@id': new URL(`${config.public.hostDomain}${item.link}`) } : {}),
              name: item.text
            }
          }
        })
      ]
    }
    ]
  ))
}
